function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useRef } from 'react';
import { useSearchBox } from 'react-instantsearch-core';
import Autosuggest from 'react-autosuggest';
import { useHits } from 'react-instantsearch';
import useAutoSuggest from '../../hooks/useAutoSuggest';
const SearchAutosuggest = props => {
  const {
    value,
    setValue
  } = useAutoSuggest();
  const {
    query,
    refine
  } = useSearchBox();
  const {
    hits
  } = useHits();
  const {
    autoCompleteDebounce = 0
  } = props;
  const timeoutRef = useRef();
  const inputProps = {
    value,
    onChange: (event, _ref) => {
      let {
        newValue
      } = _ref;
      event.persist();
      setValue(newValue);
    }
  };
  useEffect(() => {
    if (query === '') {
      setValue('');
    }
  }, [query]);
  return (
    /*#__PURE__*/
    // @ts-expect-error
    React.createElement(Autosuggest, _extends({}, props, {
      suggestions: hits
      // Explicitly put focusInputOnSuggestionClick on false.
      // Because it doesn't work together properly with the
      // renderInputComponent prop.
      ,
      focusInputOnSuggestionClick: false,
      onSuggestionsFetchRequested: _ref2 => {
        let {
          value: newValue
        } = _ref2;
        if (autoCompleteDebounce === 0) {
          refine(newValue);
        } else {
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
          timeoutRef.current = setTimeout(() => {
            refine(newValue);
          }, autoCompleteDebounce);
        }
      },
      inputProps: inputProps
    }))
  );
};
export default SearchAutosuggest;